import { useMemo } from 'react';
import { STORAGE_KEY } from './constants';

export interface AttributionPayload {
  recipientToken: string | null;
}

export function useAttributionPayload(): AttributionPayload {
  return useMemo<AttributionPayload>(() => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return { recipientToken: null };
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.recipientToken !== 'string') {
        return { recipientToken: null };
      }
      return { recipientToken: parsed.recipientToken };
    } catch {
      return { recipientToken: null };
    }
  }, []);
}
